import { Routes, Route } from 'react-router-dom';
import Login from '../pages/external/Login';
import AuthToken from '../pages/external/AuthToken';
import Cadastro from '../pages/external/Cadastro';
import SenhaNova from '../pages/external/SenhaNova';
import Dashboard from '../pages/internal/Dashboard';
import RecuperarConta from '../pages/external/RecuperarConta';

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/autenticacao" element={<AuthToken />} />
      <Route path="/senha" element={<SenhaNova />} />
      <Route path="/recuperar-conta" element={<RecuperarConta />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
}
